import createReactComponent from '../createReactComponent';
export default createReactComponent('ease-out', 'IconEaseOut', [
  ['path', { d: 'M3 20s10 -16 18 -16', key: 'svg-0' }],
]);
